import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';

class Ticker3 extends Component {


    render() {

        return (

            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
              <div class="ticker__item">ROADMAP</div>
            </div>
            </div>)
    }
}

export default Ticker3;